import { render, staticRenderFns } from "./ThreeDimensionalLayer.vue?vue&type=template&id=dabfebea&scoped=true&"
import script from "./ThreeDimensionalLayer.vue?vue&type=script&lang=js&"
export * from "./ThreeDimensionalLayer.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDimensionalLayer.vue?vue&type=style&index=0&id=dabfebea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabfebea",
  null
  
)

export default component.exports